"use strict";
//When adding constants, create objects to group them by type.
//The objects should be alphabetical in the file.
//The object properties should be kept alphabetical by name within the object defineProperty lines
//If you are creating a new constant group, make sure to add it to the Exports.

var constants = {
	mappings: [],
	add: function (type, name, value) {
		this.mappings.push({ type: type, name: name, value: value });
	}
};

var BluefinErrorCodes = {};
constants.add(BluefinErrorCodes, "BlankField", 1000);
constants.add(BluefinErrorCodes, "InputTooShort", 1001);
constants.add(BluefinErrorCodes, "InputTooLong", 1002);
constants.add(BluefinErrorCodes, "InputNotNumeric", 1003);
constants.add(BluefinErrorCodes, "InvalidCreditCard", 1004);
constants.add(BluefinErrorCodes, "InvalidExpiration", 1005);

var BluefinFieldNames = {};
constants.add(BluefinFieldNames, "CreditCard", "number");
constants.add(BluefinFieldNames, "Cvv", "cvv");
constants.add(BluefinFieldNames, "Expiration", "expy");
constants.add(BluefinFieldNames, "BankAccount", "bank account");
constants.add(BluefinFieldNames, "RoutingNumber", "routing number");

var CreditCardProviders = {};
constants.add(CreditCardProviders, "Bluefin", "BLUE");
constants.add(CreditCardProviders, "Braintree", "BRAINTREE");
constants.add(CreditCardProviders, "CardConnect", "CCONNECT");
constants.add(CreditCardProviders, "CyberSource", "CYB_SOURCE");
constants.add(CreditCardProviders, "Tsys", "TSYS");


//Function that actually applies all of the properties to the objects.
constants.mappings.forEach((constant) => {
	Object.defineProperty(constant.type, constant.name, { value: constant.value, writable: false, enumerable: true, configurable: true });
});

module.exports = {
	BluefinErrorCodes,
	BluefinFieldNames,
	CreditCardProviders
};
